import React, { useState, useEffect } from "react";
import { Input, Button, Upload, Divider } from "antd";
import {
  DeleteOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const ItineraryEditor = ({ slide, updateSlide, removeSlide, triggerSave }) => {
  const [formData, setFormData] = useState({
    bg: slide.bg || "",
    icon: slide.icon || "",
    dayNumber: slide.dayNumber || "",
    title: slide.title || "",
    date: slide.date || "",
    points: slide.points || [],
  });

  useEffect(() => {
    setFormData({
      bg: slide.bg || "",
      icon: slide.icon || "",
      dayNumber: slide.dayNumber || "",
      title: slide.title || "",
      date: slide.date || "",
      points: slide.points || [],
    });
  }, [slide]);

  useEffect(() => {
    updateSlide(slide.id, { ...slide, ...formData });
  }, [triggerSave]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (info, field) => {
    const file = info.file.originFileObj || info.file;
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => handleChange(field, reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handlePointChange = (idx, value) => {
    const updated = [...formData.points];
    updated[idx] = value;
    handleChange("points", updated);
  };

  const removePoint = (idx) => {
    const updated = formData.points.filter((_, i) => i !== idx);
    handleChange("points", updated);
  };

  const addPoint = () => {
    handleChange("points", [...formData.points, ""]);
  };

  return (
    <div className="border p-3 rounded bg-white shadow-sm">
      <Divider />
      <h1 className="font-semibold mb-4 text-lg">Edit Itinerary Slide</h1>

      <div className="mb-3">
        <Upload
          accept="image/*"
          beforeUpload={() => false}
          showUploadList={false}
          onChange={(info) => handleFileChange(info, "bg")}
        >
          <Button type="primary" icon={<UploadOutlined />}>
            Upload Background
          </Button>
        </Upload>

        {formData.bg && (
          <img
            src={formData.bg}
            alt="Background Preview"
            className="block mt-2 w-full h-32 max-w-xs object-cover rounded-lg border"
          />
        )}
      </div>

      {/* 🔹 Icon Upload */}
      <div className="mb-3">
        <Upload
          accept="image/*"
          beforeUpload={() => false}
          showUploadList={false}
          onChange={(info) => handleFileChange(info, "icon")}
        >
          <Button type="primary" icon={<UploadOutlined />}>
            Upload Icon
          </Button>
        </Upload>

        {formData.icon && (
          <img
            src={formData.icon}
            alt="Icon Preview"
            className="block mt-2 w-20 h-20 object-cover rounded-lg border"
          />
        )}
      </div>

     
      <Input
        placeholder="Day Number"
        value={formData.dayNumber}
        onChange={(e) => handleChange("dayNumber", e.target.value)}
        className="mb-2"
      />
      <Input
        placeholder="Title"
        value={formData.title}
        onChange={(e) => handleChange("title", e.target.value)}
        className="mb-2"
      />
      <Input
        placeholder="Date"
        value={formData.date}
        onChange={(e) => handleChange("date", e.target.value)}
        className="mb-2"
      />

       
      {formData.points.map((p, idx) => (
        <div key={idx} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
          <Input
            value={p}
            maxLength={200}
            onChange={(e) => handlePointChange(idx, e.target.value)}
          />
          <Button danger onClick={() => removePoint(idx)}>
            <DeleteOutlined />
          </Button>
        </div>
      ))}

      <Button
        type="dashed"
        className="mt-2 mb-3"
        icon={<PlusOutlined />}
        onClick={addPoint}
      >
        Add Point
      </Button>

      
      <div className="mt-6 flex justify-end">
        <Button danger type="primary" onClick={() => removeSlide(slide.id)}>
          <DeleteOutlined /> Remove Slide
        </Button>
      </div>
    </div>
  );
};

export default ItineraryEditor;
